<template>
  <infoSlider class="boxes" :show="itemSelect" @close="$emit('close')" label="詳細會員資訊" :width="511" :icon="'user'">
    <div class="sidepad">
    <template v-if="itemSelect">
    <label class="pages">
      <input type="radio" value="會員資料" class="page" name="page" v-model="infopage">
      <input type="radio" value="消費紀錄" class="page" name="page" v-model="infopage">
      <input type="radio" value="用餐紀錄" class="page" name="page" v-model="infopage">
      <input type="radio" value="饗食餐券" class="page" name="page" v-model="infopage" v-if="itemSelect.combo&&itemSelect.combo.length>0">
      <!-- <button class="link" @click="copylink" ref="cp"></button> -->
      <button class="link"  @click="copylink" ref="cp"></button>

    </label>
    <template v-if="infopage==='會員資料'">
    <editBox @edit="editItemfn" v-if="edit!=='info'">
      <div class="infoCol">
        <div>類型</div>
        <div>
          <span v-if="itemSelect.level">
          </span>
          {{rolesmap[itemSelect.role]||'-'}}
        </div>
      </div>
      <div class="infoCol">
        <div>會員ID</div>
        <div>{{itemSelect.memberID||'-'}} </div>
      </div>
      <div class="infoCol">
        <div>會員等級</div>
        <div class="flex" :style="{gap: '10px'}">
          <div v-if="itemSelect.level" :style="{backgroundImage: `url(.${vipImg[itemSelect.level]})`, width: '30px', height: '30px', backgroundPosition:'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}"></div>
          {{vipName[itemSelect.level] || '一般會員'}}
          <div v-if="itemSelect.levelExpTime" :style="{fontSize:'14px', color: '#C4C4C4', alignSelf:'flex-end', lineHeight: '20px'}">{{moment(itemSelect.levelExpTime).format('yyyy-MM-DD')}}</div>
        </div>
      </div>
      <div class="infoCol">
        <div></div>
        <div :style="{gap: '20px'}">
          <sqr40016 :text="'刷新LINE名稱'" :style="{marginLeft: 'auto'}" :bg="'var(--color-checked)'" @click="getProfile"/>
          <sqr40016 :text="'停用'" :style="{marginLeft: 'auto'}" :bg="'var(--highlight)'" @click="setPause"/>
        </div>
      </div>
      <div class="infoCol">
        <div>LINE名稱</div>
        <div :style="{width: '-webkit-fill-available'}">{{(itemSelect.lineName||'-')+(itemSelect.pause ? '(停用)' : '')}}</div>
      </div>
      <div class="infoCol">
        <div>名字</div>
        <div>{{itemSelect.name||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>電話</div>
        <div>{{itemSelect.mobile||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>性別</div>
        <div>{{itemSelect.gender||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>生日</div>
        <div>{{itemSelect.birthYear||'****'}}.{{itemSelect.birth?.replace('-',  '.')}}</div>
      </div>
      <div class="infoCol">
        <div>居住縣市</div>
        <div>{{itemSelect.country||'-'}}</div>
      </div>
    </editBox>
    <editBox @edit="saveInfo" v-else-if="edit==='info'" :btnHide="true">
      <div class="infoCol infoColEdit">
        <div>會員類型</div>
        <div>
          <Select1 :defaultValue="editItem.role" @input="editItem.role=$event " :style="{width: '200px'}">
            <option v-for="(k) in Object.keys(rolesmap)" :key="`role-${k}`" :value="k">{{rolesmap[k]}}</option>
          </Select1>
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div>VIP</div>
        <div :style="{gap: '20px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}">
          <input type="radio" class="vip" v-model="editItem.level" v-for="level in Object.keys(vipImg)" :value="level" :key="`level-${level}`" :style="{ backgroundImage: `url(.${vipImg[level]})` }">
          <input type="radio" class="none" v-model="editItem.level" :value="0">
        </div>
      </div>
      <div class="infoCol">
        <div>會員ID</div>
        <div>{{itemSelect.memberID||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>LINE名稱</div>
        <div>{{itemSelect.lineName||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>名字</div>
        <div>{{itemSelect.name||'-'}}</div>
      </div>
      <div class="infoCol">
        <div>電話</div>
        <div>{{itemSelect.mobile||'-'}}</div>
      </div>
      <div class="infoCol infoColEdit">
        <div>性別</div>
        <div>
          <input type="radio" class="gender" name="gender" v-model="editItem.gender" value="男" label="男">
          <input type="radio" class="gender" name="gender" v-model="editItem.gender" value="女" label="女">
          <input type="radio" class="gender" name="gender" v-model="editItem.gender" :value="null" label="其他">
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div>生日</div>
        <div>
          <Select1 :defaultValue="editItem.birth.year" @input="editItem.birth.year=$event " :width="'5.3em'">
            <option :value="null">西元年</option>
            <option v-for="y in 120" :key="`year-${y}`" :value="moment().year() - (y - 1)">{{moment().year() - (y - 1)}}</option>
          </Select1>
          <Select1 :defaultValue="editItem.birth.month" @input="editItem.birth.month=$event " :width="'4em'">
            <option :value="null">月</option>
            <option v-for="m in 12" :key="`month-${m}`" :value="m">{{m}}</option>
          </Select1>
          <Select1 :defaultValue="editItem.birth.date" @input="editItem.birth.date=$event " :width="'4em'" v-if="editItem.birth.year&&!isNaN(editItem.birth.month)">
            <option :value="null">日</option>
            <option v-for="m in moment(`${editItem.birth.year}-${editItem.birth.month}-1`).endOf('month').date()" :key="`month-${m}`" :value="m">{{m}}</option>
          </Select1>
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div>居住縣市</div>
        <div>
          <Select1 :defaultValue="editItem.country" @input="editItem.country=$event" :width="'200px'">
            <option :value="null">縣市</option>
            <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
          </Select1>
        </div>
      </div>
      <div class="btns">
        <button class="cancel" @click="edit=null">取消</button>
        <button class="confirm" @click="saveInfo">確認</button>
      </div>
    </editBox>
    <editBoxH label="群組標籤"  @edit="tags=(itemSelect.tags||[]);tag=null;edit='tags'" v-if="edit!=='tags'">
      <div class="tags" :style="{padding: 0, border: 'none', height: 'fit-content'}">
        <div v-for="(tag, t) in itemSelect.tags" :key="`tag-${t}`">{{tag}}</div>
      </div>
    </editBoxH>
    <editBoxH label="群組標籤"  @edit="saveTags" v-else-if="edit==='tags'" icon="save">
      <div class="tags" @click="$refs.tag.focus()">
        <div v-for="(opt, o) in tags" :key="`opt-${o}`" @click.stop="tags.splice(o, 1)">{{opt}}</div>
        <input type="text" placeholder="選項標籤" ref="tag"
        v-model="tag"
        @keypress.enter="tags=[...tags, tag];tag=null">
      </div>
    </editBoxH>
    <editBoxH label="內部註記"  @edit="internalRemark=itemSelect.internalRemark;edit='internalRemark'" v-if="edit!=='internalRemark'">
      <div class="remark">{{itemSelect.internalRemark}}</div>
    </editBoxH>
    <editBoxH label="內部註記"  @edit="saveInternalRemark" v-else-if="edit==='internalRemark'" icon="save">
      <textarea class="remark" v-model="internalRemark"></textarea>
    </editBoxH>
    <editBoxH label="註記"  @edit="remark=itemSelect.remark;edit='remark'" v-if="edit!=='remark'">
      <div class="remark">{{itemSelect.remark}}</div>
    </editBoxH>
    <editBoxH label="註記"  @edit="saveRemark" icon="save" v-else-if="edit==='remark'">
      <textarea class="remark" v-model="remark"></textarea>
    </editBoxH>
    <editBoxH label="黑名單"  @edit="blank=itemSelect.blank;edit='blank'" v-if="edit!=='blank'">
      <div :class="itemSelect.blank?'blankText':''">{{itemSelect.blank?'已列入黑名單': ''}}</div>
    </editBoxH>
    <editBoxH label="黑名單"  :btnHide="true" v-else-if="edit==='blank'">
      <div class="blankradio">
        <label for="blank" :style="{backgroundColor: blank?'var(--color-checked)':'#B8B8B8'}"  @click="blank=true">
          <span class="blank"></span>
        標記黑名單</label>
        <label for="unblank"  :style="{backgroundColor: !blank?'var(--color-checked)':'#B8B8B8'}" @click="blank=false">
        取消黑名單</label>
      </div>
      <div class="btns">
        <button class="cancel" @click="edit=null">取消</button>
        <button class="confirm" @click="saveBlank">確認</button>
      </div>
    </editBoxH>
    </template>
    <template v-else-if="infopage==='消費紀錄'">
      <div class="records" :style="{flex:1, gap: '15px'}">
        <div>
        <input type="radio" value="半年"  v-model="datarange">
        <input type="radio" value="一年"  v-model="datarange">
        <input type="radio" value="期間"  v-model="datarange">
        <template v-if="datarange==='期間'">
          <dateRange :defaultValue="range" @input="range=$event"/>
        </template>
        </div>
        <div :style="{border: '1px solid var(--color-pri)', flex: 1}">
          <div>
          <div>消費總額</div>
          <div>$ <span :style="{fontSize: '26px', fontWeight: 700}">{{formatDollarInt(invoicesERP.map(e => e.price).filter(e => e).reduce((a, b) => a + b, 0)).substring(1,)}}</span></div>
          </div>
          <div class="invoiceList" v-if="itemSelect">
            <div v-for="invoice in invoicesERP" :key="invoice.id" @click="openPage(invoice)">
              <div>{{toDate(invoice.visitDate)}}</div>
              <div v-if="invoice.invoiceStart">{{invoice.invoiceStart}}</div>
              <div v-else>{{invoice.id}}</div>
              <div>{{formatDollarInt(invoice.invoiceAmounts)}}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="infopage==='用餐紀錄'">
      <div class="records" :style="{flex:1, gap: '15px'}">
        <div>
        <input type="radio" value="半年"  v-model="datarange">
        <input type="radio" value="一年"  v-model="datarange">
        <input type="radio" value="期間"  v-model="datarange">
        <template v-if="datarange==='期間'">
          <dateRange :defaultValue="range" @input="range=$event"/>
        </template>
        </div>
        <div :style="{border: '1px solid var(--color-pri)', flex: 1}">
          <div>
          <div>消費總額</div>
          <div>$ <span :style="{fontSize: '26px', fontWeight: 700}">{{formatDollarInt(invoices.map(e => e.price).filter(e => e).reduce((a, b) => a + b, 0)).substring(1,)}}</span></div>
          </div>
          <div class="invoiceList" v-if="itemSelect">
            <div v-for="invoice in invoices" :key="invoice.id">
              <div>{{toDate(invoice.visitDate)}}</div>
              <div v-if="invoice.invoiceStart">{{invoice.invoiceStart}}</div>
              <div v-else>{{invoice.id}}</div>
              <div>{{formatDollarInt(invoice.price||invoice.amount)}}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <Select1 :defaultValue="able" @input="able=$event">
        <option :value="null">已購買</option>
        <option :value="true">未用盡</option>
        <option :value="0">已用盡</option>
      </Select1>
      <div v-for="(st, s) in comboGroup" :key="`st-${s}`" class="storeCombo">
        <div :style="{display: 'flex'}">{{st.store}}</div>
        <div v-for="(tt, t) in st.times" :key="`st-${s}-${t}`"  class="timeCombo">
          <div :style="{display: 'flex'}">{{tt.t}}</div>
          <div v-for="(it, i) in tt.items" :key="`st-${s}-${t}-${i}`">
            <div :style="{flex:1, display: 'flex', justifyContent: 'space-between'}">
              <span :style="{fontWeight: 700, color: 'var(--color-pri)'}">{{it.productId.name}}</span>
              <span :style="{fontWeight: 700, color: 'var(--highlight)', marginLeft: '10px'}">${{it.price}}</span>
            </div>
            <div :style="{letterSpacing: '2.4px'}"><span :style="{color: 'var(--point)', fontWeight: '700', fontSize: '22px'}">{{it.count}}</span>/{{it.orgCount}}</div>
          </div>
        </div>
      </div>
    </template>
    </template>
    </div>
  </infoSlider>
</template>

<script>
import dateRange from '../../../components/input/dateRange.vue'
import editBox from '../../../components/editBox.vue'
import editBoxH from '../../../components/editBoxWithHeader'
import infoSlider from '../../../components/infoSlider_v2.vue'
import sqr40016 from '../../../components/btn/sqr40016.vue'
import { getapi, postapi } from '../../../store/fetch'
import { mapState } from 'vuex'
export default {
  components: {
    sqr40016,
    editBoxH,
    editBox,
    infoSlider,
    dateRange
  },
  props: ['itemSelect', 'rolesmap'],
  data () {
    return {
      able: true,
      range: {
        start: null,
        end: null
      },
      blank: false,
      editBlank: false,
      datarange: '半年',
      invoices: [],
      invoicesERP: [],
      infopage: '會員資料',
      countries: [],
      birth: {
        year: null,
        month: null,
        date: null
      },
      gender: null,
      country: null,
      role: null,
      edit: false,
      editremark: false,
      editIremark: false,
      remark: null,
      edittags: false,
      tags: [],
      tag: null,
      link: null,
      editItem: null
    }
  },
  computed: {
    maxDate () {
      return this.moment().format('YYYY-MM-DD')
    },
    comboGroup () {
      let cbs
      if (this.able === 0) {
        cbs = JSON.parse(JSON.stringify(this.itemSelect.combo)).filter(e => e.count === 0)
      } else if (this.able === true) {
        cbs = JSON.parse(JSON.stringify(this.itemSelect.combo)).filter(e => e.count)
      } else {
        cbs = JSON.parse(JSON.stringify(this.itemSelect.combo))
      }
      const sts = Array.from(new Set(cbs.map(e => e.store)))
      return sts.map(st => {
        const cbsst = cbs.filter(e => e.store === st)
        const tt = Array.from(new Set(cbsst.map(e => this.toDate(e.createTime))))
        const times = tt.map(t => {
          return {
            t: t,
            items: cbsst.filter(e => this.toDate(e.createTime) === t)
          }
        })
        return {
          store: st,
          times
        }
      })
    },
    ...mapState({
      vipName: 'vipName',
      vipImg: 'vipImg'
    })
  },
  async created () {
    await this.getcounties()
  },
  watch: {
    async itemSelect () {
      this.edit = false
      this.editremark = false
      this.editBlank = false
      if (this.itemSelect && this.itemSelect.memberID) {
        await this.getInvoices()
      }
      // if (this.infopage === '消費紀錄') {
      //   this.getInvoices()
      // }
    },
    async datarange () {
      if (this.datarange !== '期間') {
        await this.getInvoices()
      } else {
        if (this.range.start && this.range.end) {
          await this.getInvoices()
        }
      }
    },
    async range () {
      if (this.datarange !== '期間') {
        await this.getInvoices()
      } else {
        if (this.range.start && this.range.end) {
          await this.getInvoices()
        }
      }
    }
  },
  methods: {
    async setPause () {
      const ret = await postapi(`users/v2/${this.itemSelect._id}`, { pause: !this.itemSelect.pause })
      if (ret) {
        this.$emit('updateItem', ret)
      }
    },
    async getProfile () {
      const ret = await getapi(`users/displayName/${this.itemSelect._id}`)
      if (ret) {
        this.$emit('updateItem', ret)
      }
    },
    async copylink () {
      const link = this.link
      try {
        await this.$copyText(link)
        this.$refs.cp.classList.add('copied')
        setTimeout(() => {
          this.$refs.cp.classList.remove('copied')
        }, 2000)
      } catch (error) {
        this.LinkError = error
      }
    },
    async getInvoices () {
      if (this.itemSelect && this.itemSelect.memberID) {
        if (this.datarange === '半年') {
          this.invoices = await getapi(`users/consume/${this.itemSelect._id}?${new URLSearchParams({
            start: this.moment().add(-6, 'month').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          })}`)
        } else if (this.datarange === '一年') {
          this.invoices = await getapi(`users/consume/${this.itemSelect._id}?${new URLSearchParams({
            start: this.moment().add(-12, 'month').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          })}`)
        } else if (this.datarange === '期間' && this.range.start && this.range.end) {
          this.invoices = await getapi(`users/consume/${this.itemSelect._id}?${new URLSearchParams({
            start: this.moment(this.range.start).startOf('day').toISOString(),
            end: this.moment(this.range.end).endOf('day').toISOString()
          })}`)
        }
      }
      if (this.itemSelect && this.itemSelect.memberID) {
        if (this.datarange === '半年') {
          this.invoicesERP = await getapi(`consumeRecords/userInvoice/${this.itemSelect.memberID}?${new URLSearchParams({
            start: this.moment().add(-6, 'month').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          })}`)
        } else if (this.datarange === '一年') {
          this.invoicesERP = await getapi(`consumeRecords/userInvoice/${this.itemSelect.memberID}?${new URLSearchParams({
            start: this.moment().add(-12, 'month').startOf('day').toISOString(),
            end: this.moment().endOf('day').toISOString()
          })}`)
        } else if (this.datarange === '期間' && this.range.start && this.range.end) {
          this.invoicesERP = await getapi(`consumeRecords/userInvoice/${this.itemSelect.memberID}?${new URLSearchParams({
            start: this.moment(this.range.start).startOf('day').toISOString(),
            end: this.moment(this.range.end).endOf('day').toISOString()
          })}`)
        }
      }
    },
    async saveInfo () {
      const itemUpdate = {}
      if (this.editItem.role && this.editItem.role !== this.itemSelect.role) {
        itemUpdate.role = this.editItem.role
      }
      if (this.editItem.gender !== this.itemSelect.gender) {
        itemUpdate.gender = this.editItem.gender
      }
      // console.log()
      if (this.editItem.birth.month && this.editItem.birth.date && this.moment(`1911-${this.editItem.birth.month}-${this.editItem.birth.date}`).format('MM-DD') !== this.itemSelect.birth) {
        itemUpdate.birth = this.moment(`1911-${this.editItem.birth.month}-${this.editItem.birth.date}`).format('MM-DD')
      }
      if (this.editItem.birth.year && String(this.editItem.birth.year) !== this.itemSelect.birthYear) {
        itemUpdate.birthYear = this.editItem.birth.year
      }
      if (this.editItem.country !== this.itemSelect.country) {
        itemUpdate.country = this.editItem.country
      }
      if (this.editItem.level !== this.itemSelect.level) {
        itemUpdate.level = this.editItem.level
      }
      if (Object.keys(itemUpdate).length > 0) {
        const ret = await postapi(`users/v2/${this.itemSelect._id}`, { ...itemUpdate })
        if (ret) {
          // console.log(ret)
          this.$emit('updateItem', ret)
          this.edit = null
        }
      } else {
        this.edit = null
      }
    },
    async saveTags () {
      const ret = await postapi(`users/v2/${this.itemSelect._id}`, { tags: this.tags })
      if (ret) {
        this.$emit('updateItem', ret)
        this.edit = null
      }
    },
    async saveBlank () {
      if (this.blank !== this.itemSelect.blank) {
        const ret = await postapi(`users/v2/${this.itemSelect._id}`, { blank: this.blank })
        if (ret) {
          // console.log(ret)
          this.$emit('updateItem', ret)
          this.edit = null
        }
      } else {
        this.edit = null
      }
    },
    async saveInternalRemark () {
      if (this.internalRemark !== this.itemSelect.internalRemark) {
        const ret = await postapi(`users/v2/${this.itemSelect._id}`, { internalRemark: this.internalRemark })
        if (ret) {
          // console.log(ret)
          this.$emit('updateItem', ret)
          this.edit = null
        }
      } else {
        this.edit = null
      }
    },
    async saveRemark () {
      if (this.remark !== this.itemSelect.remark) {
        const ret = await postapi(`users/v2/${this.itemSelect._id}`, { remark: this.remark })
        if (ret) {
          // console.log(ret)
          this.$emit('updateItem', ret)
          this.edit = null
        }
      } else {
        this.edit = null
      }
    },
    async getcounties () {
      this.countries = await getapi('selections/country')
      this.link = await getapi('selections/signupleader')
    },
    editItemfn () {
      this.editItem = {
        verified: this.itemSelect.verified,
        name: this.itemSelect.name,
        mobile: this.itemSelect.mobile,
        role: this.itemSelect.role,
        level: this.itemSelect.level,
        gender: this.itemSelect.gender,
        country: this.itemSelect.country,
        birth: {
          year: this.itemSelect.birthYear,
          ...(this.itemSelect?.birth ? {
            month: parseInt(this.itemSelect.birth.slice(0, 2)),
            date: parseInt(this.itemSelect.birth.slice(3, 5))
          } : { month: null, date: null })
        }
      }
      this.edit = 'info'
    }
  }

}
</script>

<style lang="scss">
.records {
  #setDateRange-input {
    letter-spacing: 0!important;
    font-size: 14px;
  }
  #records-wrapper {
    width: 200px;
    height: 40px;
    justify-self: flex-start;
    text-align: start;
    margin: 0;
  }
  #records-input {
    height: 40px;
    width: 200px;
    font-size: 13px;
  }
  .datepicker {
    transform: translateX(-200px);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.timeCombo {
  &>:nth-child(1) {
    height: 55px;
    background-color: var(--color-infobox);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 1em;
    color: var(--color-pri);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: .1em;
  }
  &>div:not(:nth-child(1)) {
    padding-inline: 1.2em;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    letter-spacing: 2px;
    gap: 30px;
  }

}
.storeCombo {
  border: 1px solid var(--color-pri);
  &>:nth-child(1) {
    height: 60px;
    background-color: var(--color-pri);
    color: #FFFFFF;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: .1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 1em;
  }
}
.records {
  display: flex;
  flex-direction: column;
  gap: 10px
}
div.vip, div.vvip, div.supervip {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
}

div.vip {
  background-image: url(/vip.svg);
  mask-image: none;
}
div.supervip {
  background-image: url(/supervip.svg);
  mask-image: none;
}
div.vvip {
  background-image: url(/vvip.svg);
  mask-image: none;
}
input.vip, input.vvip, input.supervip, .none {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: transparent;
  filter: contrast(.5);
  &:checked {
    filter: contrast(1);
  }
}

.none {
  background-color: #cacaca;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
  filter: contrast(1);
  &:checked {
    background-color: transparent;
  }
}
.sidepad {
  margin: 5px 10px;
  padding: 5px 24px 22px 29px;
  display: flex;
  flex-direction: column;
  gap: 21px;
  max-height: calc(100vh - 105px);
  overflow-y: auto;
  .editBox {
    min-height: fit-content;
  }
}
.tags {
    margin-top: 5px;
    width: 100%;
    height: 170px;
    border: 1px solid var(--color-checked);
    color: var(--color-checked);
    border-radius: 5px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding: 12px 17px;
    gap: 10px;
    &>div {
      font-size: 20px;
      padding: 5px 8px;
      border: 1px solid var(--color-checked);
      border-radius: 3px;
    }
    input[type=text] {
      height: 40px;
      width: 200px;
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      letter-spacing: 0.05em;
      color: #B9B9B9;
      border: none;
    }
  }
.blankradio {
  display: flex;
  flex-direction: row;
  gap: 27px;
  align-items: center;
  justify-content: center;
}
.blankradio > label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  appearance: none;
  padding: 10px 13.5px;
  background-color: #B8B8B8;
  border-radius: 3px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  &:nth-child(1) {
    padding-inline: 25px;
  }
}
.blankText {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
}
.blank {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 15px;
  width: 30px;
  height: 30px;
  &::before {
    content: '';
    width: 21px;
    height: 21px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    mask-image: url(/blank.svg);
    mask-size: 21px;
    background-color: var(--color-checked);
  }
}
.records {
  display: flex;
  flex-direction: column;
  gap: 15px;
  &>div:nth-child(1){
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 5px;
    input[type=radio] {
      margin: 0;
      appearance: none;
      width: 65px;
      height: 40px;
      background: #C4C4C4;
      border-radius: 3px;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.1em;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      &:checked {
        background-color: var(--color-checked);
      }
      &::before{
        content: attr(value);
      }
    }
  }
  &>div:nth-child(2) {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-infobox);
    border-radius: 3px;
    overflow: hidden;
    &>div:nth-child(1){
      display: flex;
      background-color: var(--color-infobox);
      padding-block: 10px;
      padding-inline: 14px 31px;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      color: var(--color-checked);
      letter-spacing: .1em;
      font-size: 18px;
      border-radius: 3px;
    }
  }
}
.invoiceList {
  flex: 1;
  margin: 7px;
  max-height: calc(100vh - 324px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 9px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
  &>div {
    padding-inline: 14px 16px;
    display: grid;
    grid-template-columns: 100px 110px 1fr;
    gap: 29px;
    font-size: 16px;
    letter-spacing: .1em;
    height: 49px;
    min-height: 49px;
    align-items: center;
    &>div:nth-child(1),
    &>div:nth-child(2) {
      text-align: start;
    }
    &>div:nth-child(3) {
      text-align: end;
    }
  }
}
.link {
  background: #CCA16E;
  border-radius: 5px;
  background-image: url(/links.svg);
  width: 40px;
  height: 40px;
  margin-left: auto;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  position: relative;
  &:hover::before {
    position: absolute;
    bottom: -35px;
    z-index: 5;
    transform: translateX(calc(-50% - 30px));
    align-items: center;
    justify-content: center;
    width: 145px;
    height: 30px;
    box-shadow: 3px 4px 15px rgba(0, 0, 0, 0.25);
    background-color: #00000080;
    color: #FFFFFF;
    display: inline-flex;
    content: '點擊複製註冊連結';
    white-space: nowrap;
    border-radius: 2px;
  }
  &.copied::before {
    display: none;
  }
  &.copied::after {
    position: absolute;
    bottom: -30px;
    z-index: 5;
    transform: translateX(calc(-50% - 30px));
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 30px;
    box-shadow: 3px 4px 15px rgba(0, 0, 0, 0.25);
    background-color: #00000080;
    color: #FFFFFF;
    display: inline-flex;
    content: '已複製';
    border-radius: 2px;
  }
}
.mt-3 {
  margin-top: 12px!important;
}
.pages {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  margin-top: 8px;
  gap: 15px;
}
input[type=radio].page {
  width: 115px;
  height: 40px;
  appearance: none;
  border: 1px solid var(--color-pri);
  border-radius: 20px;
  background-color: #FFFFFF;
  color: var(--color-pri);
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:checked {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
  &::before {
    content: attr(value);
  }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 25px;
  button {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    border: none;
  }
  .cancel {
    background-color: #B8B8B8;
  }
  .confirm {
    background-color: #E37878;
  }
}
select {
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 36px;
}
input[type=radio].gender {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 25px;
  &::before {
    content: '';
    display: inline-flex;
    border: 2px solid var(--color-pri);
    box-sizing: border-box;
    border-radius: 100px;
    width: 24px;
    height: 24px;
  }
  &:checked::before {
    background-image: url(/checked.svg);
    background-color: var(--color-checked);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: var(--color-letter);
  appearance: none;
  &::after {
    content: attr(label);
  }
}
textarea.remark {
  width: 100%;
  height: fit-content;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
  min-height: 90px;
  border: 1px solid #C4C4C4;
}
div.remark {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
}
.hrdeco {
  height: 12px;
  background-color: transparent;
  width: 100%;
  background-image: url(/hrdeco.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
}
.infofoot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #999999;
}
.footCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: end;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 32px;
}
.infoCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 27px;
  min-height: 42px;
  height: fit-content;
  &>div:nth-child(1) {
    width: 100px;
    min-width: 100px;
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: start;
  }
}
.infoColEdit {
  margin-top: 10px;
  input[type=text] {
    height: 40px;
    border-radius: 3px;
    border: 1px solid #C4C4C4;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
    padding-inline: .5em;
  }
  &>div:nth-child(1) {
    line-height: 40px;
  }
}
</style>
